//(function () {
//	function swiperInit() {
//		subSliderInit(true);
//		sliderInit(true);
//	}

//	document.addEventListener('shopify:section:load', function (e) {
//		swiperInit();
//	});

//	window.addEventListener('resize', function () {
//		$('.product-section .js-media-list').each(function () {
//			this.swiper.destroy();
//		});
//		$('.product-section .js-media-sublist').each(function () {
//			this.swiper.destroy();
//		});

//		swiperInit();
//	});

//	swiperInit();
//})();

(function () {
	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);
		updatethumbnail(true);
	}

	document.addEventListener("shopify:section:load", function (e) {
		swiperInit();
	});

	var lastWidth = window.innerWidth;
	window.addEventListener("resize", function (e) {
		if (window.innerWidth !== lastWidth) {
			lastWidth = window.innerWidth;
			swiperInit();
		}
	});

	swiperInit();

	// Re-init swipers when 3rd party app injects/replaces variant images.
	// Debounced so we wait for all DOM changes to settle before re-init.
	var refreshTimer = null;
	var subWrapper = document.querySelector(".js-media-sublist .swiper-wrapper");
	if (subWrapper) {
		new MutationObserver(function () {
			clearTimeout(refreshTimer);
			refreshTimer = setTimeout(function () {
				swiperInit();
			}, 300);
		}).observe(subWrapper, { childList: true });
	}
})();
